import React, { Component, ComponentType } from "react";
import { connect } from "react-redux";

import { getSeens } from "./action";
import { track } from "../../lib/track";
import {
  CommentType,
  RootState,
  SettingSettingData,
  UserDataState,
} from "../../types";

type StateProps = {
  user: UserDataState | {};
  setting: SettingSettingData | {};
  data?: UserDataState[];
  hasMore?: boolean;
};

type DispatchProps = {
  getSeens: (
    id: string,
    type: CommentType,
    next: boolean,
    refresh: boolean
  ) => Promise<void>;
};

export type CommentSeenByLayoutProps = {
  data?: UserDataState[];
  error: string | null;
  hasMore?: boolean;
  loading: boolean;
  refreshing: boolean;

  reFetch: (next: boolean, refresh: boolean, callback?: () => void) => void;
};

type OwnProps = {
  Layout: ComponentType<CommentSeenByLayoutProps>;
  match: {
    params?: { id?: string; type?: CommentType };
    isExact?: boolean;
    path?: string;
    url?: string;
  };
};

type Props = StateProps & DispatchProps & OwnProps;

type State = {
  error: string | null;
  loading: boolean;
  refreshing: boolean;
};

class SeenBy extends Component<Props, State> {
  state: State = {
    error: null,
    loading: false,
    refreshing: false,
  };

  componentDidMount(): void {
    this.fetchData(false, true);

    track("View Screen", {
      Screen: "seen-by",
      Params: this.props.match && this.props.match.params,
    });
  }

  fetchData = (
    next: boolean,
    refresh: boolean,
    callback?: () => void
  ): void => {
    const { getSeens, match } = this.props;
    const { refreshing, loading } = this.state;

    if (refreshing || loading) {
      return;
    }

    this.setState({ refreshing: refresh, loading: !refresh }, async () => {
      try {
        try {
          if (!match?.params?.id) throw Error("Missing comment ID");
          if (!match?.params?.type) throw Error("Missing comment type");

          const { id, type } = match.params;
          await getSeens(id, type as CommentType, next, refresh);
          this.setState({ loading: false, refreshing: false, error: null });
          callback?.();
        } catch (error) {
          this.setState({ loading: false, refreshing: false, error: error });
        }
      } catch (error) {
        this.setState({ loading: false, refreshing: false, error: error });
      }
    });
  };

  render = (): JSX.Element => {
    const { Layout, data, hasMore } = this.props;
    const { loading, error, refreshing } = this.state;
    return (
      <Layout
        error={error}
        loading={loading}
        refreshing={refreshing}
        hasMore={hasMore}
        data={data}
        reFetch={this.fetchData}
      />
    );
  };
}

const mapStateToProps = (state: RootState, ownProps: OwnProps): StateProps => {
  const { setting, comment, user } = state;
  const id = ownProps.match.params?.id;
  const { seensList } = comment;
  const { items, hasMore } = (id && seensList[id]) || {};

  return {
    user: user.data || {},
    setting: setting || {},
    data: items && Object.values(items),
    hasMore,
  };
};

const mapDispatchToProps = {
  getSeens: getSeens,
};

export default connect(mapStateToProps, mapDispatchToProps)(SeenBy);
